// extracted by mini-css-extract-plugin
module.exports = {"badgeWrapper":"styles_badgeWrapper__ZLTe2","badge":"styles_badge__jPW23","dot":"styles_dot__g3ezN","alone":"styles_alone__PBty2"};